import { JsonRpcProvider } from "ethers"

import { MEZO_NETWORK, RPC_URL_ETHEREUM, RPC_URL_MEZO } from "./env"

export const IS_MEZO_MAINNET = MEZO_NETWORK === "mezo"

export const MEZO_PROVIDER = new JsonRpcProvider(RPC_URL_MEZO)
export const ETHEREUM_PROVIDER = new JsonRpcProvider(RPC_URL_ETHEREUM)
